export const PERMISSIONS = {
  HR: {
    VIEW_EMPLOYEES: 'hr.view_employees',
    CREATE_EMPLOYEE: 'hr.create_employee',
    EDIT_EMPLOYEE: 'hr.edit_employee',
    TERMINATE_EMPLOYEE: 'hr.terminate_employee',
    VIEW_CONTRACTS: 'hr.view_contracts',
    CREATE_CONTRACT: 'hr.create_contract',
    EDIT_CONTRACT: 'hr.edit_contract',
    SIGN_CONTRACT: 'hr.sign_contract',
    VIEW_AMENDMENTS: 'hr.view_amendments',
    CREATE_AMENDMENT: 'hr.create_amendment',
    EDIT_AMENDMENT: 'hr.edit_amendment',
    APPROVE_AMENDMENT: 'hr.approve_amendment',
    VIEW_LEAVE: 'hr.view_leave',
    APPROVE_LEAVE: 'hr.approve_leave',
    VIEW_TIMESHEETS: 'hr.view_timesheets',
    GENERATE_TIMESHEETS: 'hr.generate_timesheets',
    EDIT_TIMESHEETS: 'hr.edit_timesheets',
    APPROVE_TIMESHEETS: 'hr.approve_timesheets',
    APPROVE_DATA_CHANGE: 'hr.approve_data_change',
    APPROVE_DATA_CHANGE_CHIEF: 'hr.approve_data_change_chief',
  },
  ACCOUNTING: {
    VIEW_PAYROLL: 'accounting.view_payroll',
    GENERATE_PAYROLL: 'accounting.generate_payroll',
    APPROVE_PAYROLL: 'accounting.approve_payroll',
    PAY_PAYROLL: 'accounting.pay_payroll',
    DELETE_PAYROLL: 'accounting.delete_payroll',
    VIEW_REPORTS: 'accounting.view_reports',
    VIEW_TAX_REPORTS: 'accounting.view_tax_reports',
    VIEW_DASHBOARD: 'accounting.view_dashboard',
    VIEW_GPH: 'accounting.view_gph',
    APPROVE_GPH: 'accounting.approve_gph',
    PAY_GPH: 'accounting.pay_gph',
    MANAGE_SETTINGS: 'accounting.manage_settings',
    VIEW_INCOME: 'accounting.view_income',
    CREATE_INCOME: 'accounting.create_income',
    CONFIRM_INCOME: 'accounting.confirm_income',
    DELETE_INCOME: 'accounting.delete_income',
    VIEW_PROJECT_TABLE: 'accounting.view_project_table',
    VIEW_ADVANCES: 'accounting.view_advances',
  },
  LEGAL: {
    VIEW_AGREEMENTS: 'legal.view_agreements',
    CREATE_AGREEMENT: 'legal.create_agreement',
    EDIT_AGREEMENT: 'legal.edit_agreement',
    SIGN_AGREEMENT: 'legal.sign_agreement',
    VIEW_ACTS: 'legal.view_acts',
    CREATE_ACT: 'legal.create_act',
    EDIT_ACT: 'legal.edit_act',
    APPROVE_ACT: 'legal.approve_act',
    VIEW_RENTAL: 'legal.view_rental',
    CREATE_RENTAL: 'legal.create_rental',
    APPROVE_RENTAL: 'legal.approve_rental',
    PAY_RENTAL: 'legal.pay_rental',
    MANAGE_DOCUMENTS: 'legal.manage_documents',
  },
  WAREHOUSE: {
    VIEW_INVENTORY: 'warehouse.view_inventory',
    CREATE_INVENTORY: 'warehouse.create_inventory',
    EDIT_INVENTORY: 'warehouse.edit_inventory',
    RECEIVE_INVENTORY: 'warehouse.receive_inventory',
    WRITE_OFF: 'warehouse.write_off',
    VIEW_ASSIGNMENTS: 'warehouse.view_assignments',
    ASSIGN_ASSETS: 'warehouse.assign_assets',
    RETURN_ASSETS: 'warehouse.return_assets',
    VIEW_VENDORS: 'warehouse.view_vendors',
    MANAGE_VENDORS: 'warehouse.manage_vendors',
    VIEW_REPORTS: 'warehouse.view_reports',
    APPROVE_INVOICE: 'warehouse.approve_invoice',
    PAY_INVOICE: 'warehouse.pay_invoice',
    REQUEST_ITEM: 'warehouse.request_item',
    VIEW_OWN_REQUESTS: 'warehouse.view_own_requests',
    APPROVE_REQUEST: 'warehouse.approve_request',
    FULFILL_REQUEST: 'warehouse.fulfill_request',
  },
  ADMIN: {
    VIEW_USERS: 'admin.view_users',
    MANAGE_USERS: 'admin.manage_users',
    VIEW_ROLES: 'admin.view_roles',
    MANAGE_ROLES: 'admin.manage_roles',
    MANAGE_SETTINGS: 'admin.manage_settings',
  },
  SELF: {
    VIEW_PROFILE: 'self.view_profile',
    EDIT_PROFILE: 'self.edit_profile',
    VIEW_PAYSLIPS: 'self.view_payslips',
    VIEW_TIMESHEETS: 'self.view_timesheets',
    APPLY_LEAVE: 'self.apply_leave',
    SUBMIT_ACT: 'self.submit_act',
    REQUEST_DATA_CHANGE: 'self.request_data_change',
  },
  PROJECTS: {
    VIEW_BOARD: 'projects.view_board',
    MANAGE_TASKS: 'projects.manage_tasks',
    ASSIGN_TASKS: 'projects.assign_tasks',
    REORDER_TASKS: 'projects.reorder_tasks',
    UPDATE_OWN_STATUS: 'projects.update_own_status',
    ADD_COMMENTS: 'projects.add_comments',
    EDIT_PROJECT: 'projects.edit_project',
    VIEW_VOLUNTEERS: 'projects.view_volunteers',
    CREATE_VOLUNTEER: 'projects.create_volunteer',
    EDIT_VOLUNTEER: 'projects.edit_volunteer',
  },
  FSM: {
    REVIEW_REPORT: 'fsm.review_report',
    VIEW_ALL_REPORTS: 'fsm.view_all_reports',
  },
  CHAT: {
    MANAGE_CHANNELS: 'chat.manage_channels',
  },
} as const;

export const ALL_PERMISSIONS = [
  PERMISSIONS.HR.VIEW_EMPLOYEES,
  PERMISSIONS.HR.CREATE_EMPLOYEE,
  PERMISSIONS.HR.EDIT_EMPLOYEE,
  PERMISSIONS.HR.TERMINATE_EMPLOYEE,
  PERMISSIONS.HR.VIEW_CONTRACTS,
  PERMISSIONS.HR.CREATE_CONTRACT,
  PERMISSIONS.HR.EDIT_CONTRACT,
  PERMISSIONS.HR.SIGN_CONTRACT,
  PERMISSIONS.HR.VIEW_AMENDMENTS,
  PERMISSIONS.HR.CREATE_AMENDMENT,
  PERMISSIONS.HR.EDIT_AMENDMENT,
  PERMISSIONS.HR.APPROVE_AMENDMENT,
  PERMISSIONS.HR.VIEW_LEAVE,
  PERMISSIONS.HR.APPROVE_LEAVE,
  PERMISSIONS.HR.VIEW_TIMESHEETS,
  PERMISSIONS.HR.GENERATE_TIMESHEETS,
  PERMISSIONS.HR.EDIT_TIMESHEETS,
  PERMISSIONS.HR.APPROVE_TIMESHEETS,
  PERMISSIONS.HR.APPROVE_DATA_CHANGE,
  PERMISSIONS.HR.APPROVE_DATA_CHANGE_CHIEF,
  PERMISSIONS.ACCOUNTING.VIEW_PAYROLL,
  PERMISSIONS.ACCOUNTING.GENERATE_PAYROLL,
  PERMISSIONS.ACCOUNTING.APPROVE_PAYROLL,
  PERMISSIONS.ACCOUNTING.PAY_PAYROLL,
  PERMISSIONS.ACCOUNTING.DELETE_PAYROLL,
  PERMISSIONS.ACCOUNTING.VIEW_REPORTS,
  PERMISSIONS.ACCOUNTING.VIEW_TAX_REPORTS,
  PERMISSIONS.ACCOUNTING.VIEW_DASHBOARD,
  PERMISSIONS.ACCOUNTING.VIEW_GPH,
  PERMISSIONS.ACCOUNTING.APPROVE_GPH,
  PERMISSIONS.ACCOUNTING.PAY_GPH,
  PERMISSIONS.ACCOUNTING.MANAGE_SETTINGS,
  PERMISSIONS.ACCOUNTING.VIEW_INCOME,
  PERMISSIONS.ACCOUNTING.CREATE_INCOME,
  PERMISSIONS.ACCOUNTING.CONFIRM_INCOME,
  PERMISSIONS.ACCOUNTING.DELETE_INCOME,
  PERMISSIONS.ACCOUNTING.VIEW_PROJECT_TABLE,
  PERMISSIONS.ACCOUNTING.VIEW_ADVANCES,
  PERMISSIONS.LEGAL.VIEW_AGREEMENTS,
  PERMISSIONS.LEGAL.CREATE_AGREEMENT,
  PERMISSIONS.LEGAL.EDIT_AGREEMENT,
  PERMISSIONS.LEGAL.SIGN_AGREEMENT,
  PERMISSIONS.LEGAL.VIEW_ACTS,
  PERMISSIONS.LEGAL.CREATE_ACT,
  PERMISSIONS.LEGAL.EDIT_ACT,
  PERMISSIONS.LEGAL.APPROVE_ACT,
  PERMISSIONS.LEGAL.VIEW_RENTAL,
  PERMISSIONS.LEGAL.CREATE_RENTAL,
  PERMISSIONS.LEGAL.APPROVE_RENTAL,
  PERMISSIONS.LEGAL.PAY_RENTAL,
  PERMISSIONS.LEGAL.MANAGE_DOCUMENTS,
  PERMISSIONS.WAREHOUSE.VIEW_INVENTORY,
  PERMISSIONS.WAREHOUSE.CREATE_INVENTORY,
  PERMISSIONS.WAREHOUSE.EDIT_INVENTORY,
  PERMISSIONS.WAREHOUSE.RECEIVE_INVENTORY,
  PERMISSIONS.WAREHOUSE.WRITE_OFF,
  PERMISSIONS.WAREHOUSE.VIEW_ASSIGNMENTS,
  PERMISSIONS.WAREHOUSE.ASSIGN_ASSETS,
  PERMISSIONS.WAREHOUSE.RETURN_ASSETS,
  PERMISSIONS.WAREHOUSE.VIEW_VENDORS,
  PERMISSIONS.WAREHOUSE.MANAGE_VENDORS,
  PERMISSIONS.WAREHOUSE.VIEW_REPORTS,
  PERMISSIONS.WAREHOUSE.APPROVE_INVOICE,
  PERMISSIONS.WAREHOUSE.PAY_INVOICE,
  PERMISSIONS.WAREHOUSE.REQUEST_ITEM,
  PERMISSIONS.WAREHOUSE.VIEW_OWN_REQUESTS,
  PERMISSIONS.WAREHOUSE.APPROVE_REQUEST,
  PERMISSIONS.WAREHOUSE.FULFILL_REQUEST,
  PERMISSIONS.ADMIN.VIEW_USERS,
  PERMISSIONS.ADMIN.MANAGE_USERS,
  PERMISSIONS.ADMIN.VIEW_ROLES,
  PERMISSIONS.ADMIN.MANAGE_ROLES,
  PERMISSIONS.ADMIN.MANAGE_SETTINGS,
  PERMISSIONS.SELF.VIEW_PROFILE,
  PERMISSIONS.SELF.EDIT_PROFILE,
  PERMISSIONS.SELF.VIEW_PAYSLIPS,
  PERMISSIONS.SELF.VIEW_TIMESHEETS,
  PERMISSIONS.SELF.APPLY_LEAVE,
  PERMISSIONS.SELF.SUBMIT_ACT,
  PERMISSIONS.SELF.REQUEST_DATA_CHANGE,
  PERMISSIONS.PROJECTS.VIEW_BOARD,
  PERMISSIONS.PROJECTS.MANAGE_TASKS,
  PERMISSIONS.PROJECTS.ASSIGN_TASKS,
  PERMISSIONS.PROJECTS.REORDER_TASKS,
  PERMISSIONS.PROJECTS.UPDATE_OWN_STATUS,
  PERMISSIONS.PROJECTS.ADD_COMMENTS,
  PERMISSIONS.PROJECTS.EDIT_PROJECT,
  PERMISSIONS.PROJECTS.VIEW_VOLUNTEERS,
  PERMISSIONS.PROJECTS.CREATE_VOLUNTEER,
  PERMISSIONS.PROJECTS.EDIT_VOLUNTEER,
  PERMISSIONS.FSM.REVIEW_REPORT,
  PERMISSIONS.FSM.VIEW_ALL_REPORTS,
  PERMISSIONS.CHAT.MANAGE_CHANNELS,
] as const;

export type Permission = typeof ALL_PERMISSIONS[number];

